module.exports = __webpack_public_path__ + "img/mountE_logo.976cad72.png";